import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import type { FormsFilter, FormsState } from '../types';

const initialState: FormsState = {
  items: [],
  loading: false,
  error: null,
  filter: { query: '', status: 'all', category: 'all' },
  metrics: { total: 0, active: 0 },
};


const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    setFilter(state, action: PayloadAction<Partial<FormsFilter>>) {
      state.filter = { ...state.filter, ...action.payload } as FormsFilter;
    },
  },
  extraReducers: () => {},
});

export const { setFilter } = formsSlice.actions;

export const selectForms = (state: RootState) => state.forms;

export default formsSlice.reducer;


